<h3 mat-dialog-title>
    {{ title }}
</h3>
<div mat-dialog-content>
    <div [innerHTML]="message"></div>
</div>
<div mat-dialog-actions style="display: flex; justify-content: space-between; align-items: center; gap: 12px;">
    <button mat-button *ngFor="let option of options" [mat-dialog-close]="option.id">{{ option.label }}</button>
</div>
